import { render } from "./algorithmsCreate.vue?vue&type=template&id=4071de35"
const script = {}

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__